<template>
  <v-dialog
      v-model="dialogShowChart"
      persistent
      max-width="100%"
      :retain-focus="false"
      scrollable
  >
  <v-card class="update-chart-full pt-4 pb-4 rounded-0" height="auto" min-height="90vh">
    <div class="">
      <v-btn absolute right top icon x-small @click="closeShowPreview()" style="z-index: 1;"><v-icon>mdi-close</v-icon></v-btn>
      </div>
      <!-- <v-divider class="ma-4" style="position: absolute;"/> -->
      <!-- <pre>{{ JSON.stringify(dataChart, null, '\t') }}</pre> -->
      <FullLoading :loading="loading" style="margin-top: 30vh;"/>
      <div class="main-container" v-if="dialogShowChart">
        <div id="chart-container-full-update" style="height: 80vh;"></div>
      </div>
      <v-container fluid style="position: absolute;">
        <v-layout column class="fab-container">
          <v-row>
            <v-card
              v-show="!loading"
              outlined
              width="92"
              height="28"
              style="border: 1px solid #C7C7C7'; position: fixed; top: 60px; right: 75px;"
            ></v-card>
            <v-btn
              id="zoomIn-Full"
              class="mx-2"
              :style="`margin-top: 44px; right: 68px;`"
              icon
              tile
              small
              top
              right
              floating
              fixed
              color="#999999"
              v-show="!loading"
              :dark="!percent==175"
              :disabled="percent==175"
            >
              <v-icon dark>
                mdi-plus
              </v-icon>
            </v-btn>
            <v-btn
              class="mx-2"
              :style="`margin-top: 44px; right: 81px;`"
              tile
              small
              top
              right
              floating
              fixed
              text
              disabled
              color="#999999"
              v-show="!loading"
            >
              {{ percent }}%
            </v-btn>
            <v-btn
              id="zoomOut-Full"
              class="mx-2"
              :style="`margin-top: 44px; right: 129px;`"
              icon
              tile
              small
              top
              right
              floating
              fixed
              color="#999999"
              v-show="!loading"
              :dark="!percent==25"
              :disabled="percent==25"
            >
              <v-icon dark>
                mdi-minus
              </v-icon>
            </v-btn>
          </v-row>
      </v-layout>
      </v-container>
  </v-card>
  </v-dialog>
</template>
<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/es6-promise/4.1.1/es6-promise.auto.min.js"></script>
<script type="text/javascript" src="js/jquery.min.js"></script>
<script>
import $ from 'jquery'
import { EventBus } from '@/EventBus'
import FullLoading from '../../_template/FullLoading.vue'

export default {
  props: {
  },
  components: {
    FullLoading
  },
  name: 'dialog-show-chart',
  data () {
    return {
      dialogShowChart: false,
      scrollPosition: 0,
      offset: 128,
      offsetTop: 0,
      dialog: false,
      showBtn: false,
      zoomval: 1,
      img64Array: [],
      zoomCount: 0,
      canExport: true,
      loading: false,
      loadingOrgchart: false,
      dataChart: [],
      noData: false,
      loading: false,
      percent: 100,
      colorSet: {
        'สายงาน': '#3D5D85',
        'ฝ่ายงาน': '#5CC2EF',
        'ส่วนงาน': '#6FB540',
        'หน่วยงาน': '#F2BE47;',
        'กลุ่มงาน': '#F37959',
      },
      oc: null,
      orgchart: null
    }
  },
  watch: {},
  mounted () {
    window.addEventListener('scroll', this.updateScroll)
    EventBus.$on('openDialogShowChartFull', async (e) => {
      if (e) {
        await this.showPreview(e)
      }
    })
  },
  beforeDestroy () {
    EventBus.$off('openDialogShowChartFull')
  },
  computed: {
    showTools () {
      return JSON.stringify(this.dataChart) !== '{}'
    }
  },
  async created () {
  },
  methods: {
    async showPreview (value) {
      // console.log('showPreview')
      this.dialogShowChart = true
      this.loading = true
      this.dataChart = JSON.parse(JSON.stringify(value))
      setTimeout(async () => {
        await this.createChart(this.dataChart)
      }, 500)
      this.loading = false
    },
    closeShowPreview () {
      // EventBus.$emit('closeDialogShowChart')
      this.dialogShowChart = false
    },
    updateScroll () {
      this.scrollPosition = window.scrollY
    },
    nodeTemplate (datasource) {
      {
        if (datasource.img64 === 'data:image/jpeg;base64,') {
          datasource.img64 = '/img/icons/noname.jpg'
        }
        let cssProfileImage = `
        width: 32px;
        height: 32px;
        max-width: 32px !important;
        object-fit: cover;
        border-radius: 50%;
        border : solid;
        border-color: #D3D3D3;
        border-width: thin;
        `
        let cssNode = `
        text-align: center;
        justify-content: center;
        align-items: center;
        padding: 6px 6px 8px;
        width: 200px;
        background: #FFFFFF;
        border: 1px solid ${datasource.nodePreView? this.colorSet[datasource.type]:'#C7C7C7'};
        box-sizing: border-box;
        border-radius: 4px;
        `
        let imagUI = datasource.img==undefined? ``:`<img src="${datasource.img64}" style="${cssProfileImage}"/>`

        let partTitle = `
          <p style="
            margin-top: 2.5px;
            margin-bottom: 2.5px;
            font-family: Sarabun;
            font-style: normal;
            font-weight: bold;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            color: #333333;
          ">${datasource.type=='company'? 'บริษัท':''||''} ${datasource.title||''}</p>
        `

        // var leaderData = datasource.leaderId ? self.itemLeaders.find(el => el._id === datasource.leaderId) : null
        // if (datasource.leaderId) console.log(datasource.leaderId, datasource.searchLeader)
        // else console.log('no leader')
        let partName = `
          <p style="
            margin-top: 5px;
            margin-bottom: 2.5px;
            font-family: Sarabun;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            color: #333333;
          ">${datasource.leaderId? datasource.name.replace('(รก.)', '')||'':''}${datasource.leaderTemp? '(รก.)':''}</p>
        `
        let partPostion = `
          <p style="
            margin-top: 5px;
            margin-bottom: 2.5px;
            font-family: Sarabun;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            color: #757575;
          ">${datasource.leaderId? datasource.position||'':''}</p>
        `

        return `
        <div style="
        ${cssNode}
        ">
          <div class="custom-user">
            ${imagUI}
            ${datasource.title? partTitle:''}
            ${datasource.leaderId? '<hr style="margin-top: 4px;">':''}
            ${datasource.leaderId? partName:''}
            ${datasource.leaderId? partPostion:''}
          </div>
        </div>
        `
        // word-wrap: break-word;
      }
    },
    async createChart (data) {
      var oc1 = $('#chart-container-full-update').empty()
      var oc2 = $('#chart-container-full-update .orgchart').empty()
      $('#zoomIn-Full').unbind('click')
      $('#zoomOut-Full').unbind('click')
      var self = this
      self.percent = 100
      self.zoomval = 1
      self.oc = null
      self.oc = $('#chart-container-full-update').orgchart({
        chartClass: 'chart-container-full-update',
        data : data,
        nodeTitle: 'type',
        nodeContent: 'title',
        nodeId: 'id',
        // parentNodeSymbol: 'pid',
        verticalLevel: 8,
        // visibleLevel: 6,
        // 'direction': 'b2t',
        // 'direction': 'l2r',
        // 'depth': 1,
        // 'verticalDepth': 3,
        pan: false,
        zoom: false,
        // zoominLimit: 3,
        // zoomoutLimit: 1,
        draggable: false,
        nodeTemplate: this.nodeTemplate,
        exportButton: false,
        exportFilename: 'orgchart',
        exportFileextension: 'png',
        'initCompleted': function(){
          setTimeout( function(){
            // center the chart to container
            var $container = $('#chart-container-full-update');
            var $chart = $('#chart-container-full-update .orgchart');
            $chart.addClass('noncollapsable'); // deactivate
            $chart.css('transform', `scale(${self.zoomval}, ${self.zoomval})`)
            // $chart.css('transform', "scale(1,1)");
          }  , 0 );
        },
      });
      self.orgchart = $('#chart-container-full-update .orgchart');
      // zoom buttons
      $('#zoomIn-Full').on('click', function () {
        if (self.zoomCount <= 2) {
          self.percent+=25
          self.zoomval+= 0.1235;
          self.zoomCount++
          self.oc.$chart.css('transform', `scale(${self.zoomval}, ${self.zoomval})`)
        }
      });
      $('#zoomOut-Full').on('click', function () {
        if (self.zoomCount >= -2) {
          self.percent-=25
          self.zoomval-=0.1235;
          self.zoomCount--
          if (self.zoomCount.toFixed(1) <= 1.2 ) {
            self.oc.$chart.css('transform', `scale(${self.zoomval}, ${self.zoomval})`)
          }
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>

.update-chart-full ::v-deep {
  #zoomIn {
    // padding: 50px;
    // margin-right: 100px;
    // right: 135px;
  }
  #zoomOut {
    // padding: 50px;
    // margin-right: 100px;
    // right: 90px;
  }

  .full-screen-btn{
    cursor: pointer;
  }

  .full-screen-btn:hover {
    background-color: #FAFAFA;
  }

  #btn-export{
    right: -18px;
    top: -18px;
  }

  .fab-container {
  //   position: fixed;
  //   bottom: 0;
  //   right: 0;
  }

  .main-container {
    // margin-top: -25px;
    // min-height: 300px;
    // height: 45vh;
    // overflow: hidden;
    overflow: auto;
  }

  .chart-custom {
    // position: relative;
    // display: inline-block;
    // width: calc(100%);
    // overflow: scroll;
  }

  .chart-container-full-update {
    // padding: -1000px;
    // margin: 0px;
    // position: relative;
    // display: inline-block;
    // height: 600px;
    // height: calc(100% - 240px);
    // width: calc(100%);
    // border: 2px dashed #aaa;
    // border-radius: 5px;
    // overflow: auto;
    // text-align: center;
    // transform: scale(0.8);
    // transform: scale(0.24);
    // transform-origin: 0 0;
    min-width: 90%;
    width: 90%;
    max-width: 90vw;
    // overflow: auto;
    text-align: center;
  }

  .custom-name {
    font-size: 12px;
    margin: 5px 0 0;
    font-weight: 100;
  }
  .custom-role {
    font-size: 20px;
    font-weight: 80;
    margin-bottom: 10px;
    // margin-top: 5px;
  }
  .custom-manager {
    font-size: 12px;
    color: #b21e04;
  }

  .border-chart {
    // text-decoration: none;
    // color: #666;
    font-family: arial, verdana, tahoma;
    display: inline-block;
    padding: 10px 10px;
    // transition: all 0.5s;
    // background: #fff;
    min-width: 220px;
    border-radius: 6px;
    // display:flex;
    // align-items:center;
    // justify-content:center;
    // flex-direction:column;
    box-shadow: 0 1px 3px rgba(black, 0.12), 0 1px 2px rgba(black, 0.24);
  }

  .img-border-chart {
    width: 5vw;
    height: 5vw;
    max-width: 5vw !important;
    border-radius: 50%;
    object-fit: cover;
    border-radius: 50%;
    box-shadow: 0 0 0 5px #aaa;
  }

  .chart-menu {
      border-width: 10px !important;
      border-color: #aeaeae !important;
      border: 1px solid #aeaeae !important
    }
    [data-item] {
      border-width: 0px !important;
      padding: 10px !important;
    }
    [data-tlbr] {
      margin: 20px !important;
    }
    [data-tlbr="layout"] {
        transform: rotate(0deg) translateX(0px) translateY(0px) !important;
    }
    .shadow {
      -webkit-filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .25));
      filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .25));
    }
    /* [node-id] rect {
      fill: #CAE3CC;
    } */
    text {
    font-family: 'Sarabun', sans-serif !important;
    /* font-weight: bold; */
    font-size: 28px;
  }

  .org-chart {
    display: flex;
    justify-content: center;
    ul {
      padding-top: 20px;
      position: relative;
      transition: all 0.5s;
      ul::before {
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        border-left: 1px solid #ccc;
        /* // width: 0;
        //height: 20px; */
      }
    }
    li {
      float: left;
      text-align: center;
      list-style-type: none;
      position: relative;
      padding: 10px 10px 10px 10px;
      transition: all 0.5s;
    }
  }

  .orgchart ~ .mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .orgchart ~ .mask .spinner {
    position: absolute;
    top: calc(50% - 54px);
    left: calc(50% - 54px);
    color: rgba(255, 255, 255, 0.8);
    font-size: 108px;
  }
  .orgchart .node {
    transition: transform 0.3s, opacity 0.3s;
  }
  .orgchart .slide-down {
    opacity: 0;
    transform: translateY(40px);
  }
  .orgchart.l2r .node.slide-down,
  .orgchart.r2l .node.slide-down {
    transform: translateY(130px);
  }
  .orgchart .slide-up {
    opacity: 0;
    transform: translateY(-40px);
  }
  .orgchart.l2r .node.slide-up,
  .orgchart.r2l .node.slide-up {
    transform: translateY(-130px);
  }
  .orgchart .slide-right {
    opacity: 0;
    transform: translateX(130px);
  }
  .orgchart.l2r .node.slide-right,
  .orgchart.r2l .node.slide-right {
    transform: translateX(40px);
  }
  .orgchart .slide-left {
    opacity: 0;
    transform: translateX(-130px);
  }
  .orgchart.l2r .node.slide-left,
  .orgchart.r2l .node.slide-left {
    transform: translateX(-40px);
  }

  .orgchart .hidden,
  .orgchart ~ .hidden {
    display: none;
  }
  .orgchart.b2t {
    transform: rotate(180deg);
  }
  .orgchart.l2r {
    position: absolute;
    transform: rotate(-90deg) rotateY(180deg);
    transform-origin: left top;
  }
  .orgchart .verticalNodes ul {
    list-style: none;
    margin: 0;
    padding-left: 18px;
    text-align: left;
  }
  .orgchart .verticalNodes ul:first-child {
    margin-top: 2px;
  }
  .orgchart .verticalNodes > td::before {
    content: "";
    border: 1px solid #999999;
  }
  .orgchart .verticalNodes > td > ul > li:first-child::before {
    box-sizing: border-box;
    top: -4px;
    height: 30px;
    width: calc(50% - 2px);
    border-width: 2px 0 0 2px;
  }
  .orgchart .verticalNodes ul > li {
    position: relative;
  }
  .orgchart .verticalNodes ul > li::before,
  .orgchart .verticalNodes ul > li::after {
    box-sizing: border-box;
    content: "";
    position: absolute;
    left: -6px;
    border-color: #999999;
    border-style: solid;
    border-width: 0 0 2px 2px;
  }
  .orgchart .verticalNodes ul > li::before {
    top: -4px;
    height: 30px;
    width: 11px;
  }
  .orgchart .verticalNodes ul > li::after {
    top: 1px;
    height: 100%;
  }
  .orgchart .verticalNodes ul > li:first-child::after {
    box-sizing: border-box;
    top: 24px;
    width: 11px;
    border-width: 2px 0 0 2px;
  }
  .orgchart .verticalNodes ul > li:last-child::after {
    box-sizing: border-box;
    border-width: 2px 0 0;
  }
  .orgchart.r2l {
    position: absolute;
    transform: rotate(90deg);
    transform-origin: left top;
  }
  .orgchart > .spinner {
    font-size: 100px;
    margin-top: 30px;
    color: rgba(68, 157, 68, 0.8);
  }
  .orgchart table {
    border-spacing: 0;
    border-collapse: separate;
  }
  .orgchart > table:first-child {
    margin: 20px auto;
  }
  .orgchart td {
    text-align: center;
    vertical-align: top;
    padding: 0;
  }
  .orgchart .lines:nth-child(3) td {
    box-sizing: border-box;
    height: 20px;
  }
  .orgchart .lines .topLine {
    border-top: 2px solid #999999;
  }
  .orgchart .lines .rightLine {
    border-right: 1px solid #999999;
    float: none;
    border-radius: 0;
  }
  .orgchart .lines .leftLine {
    border-left: 1px solid #999999;
    float: none;
    border-radius: 0;
  }
  .orgchart .lines .downLine {
    background-color: #999999;
    margin: 0 auto;
    height: 20px;
    width: 2px;
    float: none;
  }
  /* node styling */
  .orgchart .node {
    box-sizing: border-box;
    display: inline-block;
    position: relative;
    margin: 0;
    padding: 3px;
    border: 2px dashed transparent;
    text-align: center;
    width: auto !important;
  }
  .orgchart.l2r .node,
  .orgchart.r2l .node {
    width: 50px;
    height: 130px;
  }
  .orgchart .node > .spinner {
    position: absolute;
    top: calc(50% - 15px);
    left: calc(50% - 15px);
    vertical-align: middle;
    font-size: 30px;
    color: rgba(68, 157, 68, 0.8);
  }
  .orgchart .node:hover {
    background-color: rgba(238, 217, 54, 0.5);
    background-color: transparent !important;
    transition: 0.5s;
    cursor: default;
    z-index: 20;
  }
  .orgchart .node.focused {
    background-color: transparent !important;
    // box-shadow:0px 0px 0px 10px #3776E9 inset;
  }
  .orgchart .ghost-node {
    position: fixed;
    left: -10000px;
    top: -10000px;
  }
  .orgchart .ghost-node rect {
    fill: #ffffff;
    stroke: #999999;
  }
  .orgchart .node.allowedDrop {
    border-color: rgba(68, 157, 68, 0.9);
  }
  .orgchart .node .title {
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    height: 20px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background-color: #999999;
    color: #fff;
    border-radius: 4px 4px 0 0;
  }
  .orgchart.b2t .node .title {
    transform: rotate(-180deg);
    transform-origin: center bottom;
  }
  .orgchart.l2r .node .title {
    transform: rotate(-90deg) translate(-40px, -40px) rotateY(180deg);
    transform-origin: bottom center;
    width: 120px;
  }
  .orgchart.r2l .node .title {
    transform: rotate(-90deg) translate(-40px, -40px);
    transform-origin: bottom center;
    width: 120px;
  }
  .orgchart .node .title .symbol {
    float: left;
    margin-top: 4px;
    margin-left: 2px;
  }
  .orgchart .node .content {
    box-sizing: border-box;
    width: 100%;
    height: 20px;
    font-size: 11px;
    line-height: 18px;
    border: 1px solid #999999;
    border-radius: 0 0 4px 4px;
    text-align: center;
    background-color: #fff;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .orgchart.b2t .node .content {
    transform: rotate(180deg);
    transform-origin: center top;
  }
  .orgchart.l2r .node .content {
    transform: rotate(-90deg) translate(-40px, -40px) rotateY(180deg);
    transform-origin: top center;
    width: 120px;
  }
  .orgchart.r2l .node .content {
    transform: rotate(-90deg) translate(-40px, -40px);
    transform-origin: top center;
    width: 120px;
  }
  .orgchart .node .edge {
    font-size: 15px;
    position: absolute;
    color: rgba(68, 157, 68, 0.5);
    cursor: default;
    transition: 0.2s;
  }
  .orgchart.noncollapsable .node .edge {
    display: none;
  }
  .orgchart .edge:hover {
    color: #449d44;
    cursor: pointer;
  }
  .orgchart .node .verticalEdge {
    width: calc(100% - 10px);
    width: -webkit-calc(100% - 10px);
    width: -moz-calc(100% - 10px);
    left: 5px;
  }
  .orgchart .node .topEdge {
    top: -4px;
  }
  .orgchart .node .bottomEdge {
    bottom: -4px;
  }
  .orgchart .node .horizontalEdge {
    width: 15px;
    height: calc(100% - 10px);
    height: -webkit-calc(100% - 10px);
    height: -moz-calc(100% - 10px);
    top: 5px;
  }
  .orgchart .node .rightEdge {
    right: -4px;
  }
  .orgchart .node .leftEdge {
    left: -4px;
  }
  .orgchart .node .horizontalEdge::before {
    position: absolute;
    top: calc(50% - 7px);
  }
  .orgchart .node .rightEdge::before {
    right: 3px;
  }
  .orgchart .node .leftEdge::before {
    left: 3px;
  }
  .orgchart .node .toggleBtn {
    position: absolute;
    left: 5px;
    bottom: -2px;
    color: rgba(68, 157, 68, 0.6);
  }
  .orgchart .node .toggleBtn:hover {
    color: rgba(68, 157, 68, 0.8);
  }
  .oc-export-btn {
    width: 76px;
    height: 34px;
    padding-top: -20px;
    top: 0px;
  /* //   display: inline-block; */
    position: absolute;
  }

  .orgchart ~ .mask {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .orgchart ~ .mask .spinner {
    position: absolute;
    top: calc(50% - 54px);
    left: calc(50% - 54px);
    color: rgba(255, 255, 255, 0.8);
    font-size: 108px;
  }
  .orgchart .node {
    transition: transform 0.3s, opacity 0.3s;
  }
  .orgchart .slide-down {
    opacity: 0;
    transform: translateY(40px);
  }
  .orgchart.l2r .node.slide-down,
  .orgchart.r2l .node.slide-down {
    transform: translateY(130px);
  }
  .orgchart .slide-up {
    opacity: 0;
    transform: translateY(-40px);
  }
  .orgchart.l2r .node.slide-up,
  .orgchart.r2l .node.slide-up {
    transform: translateY(-130px);
  }
  .orgchart .slide-right {
    opacity: 0;
    transform: translateX(130px);
  }
  .orgchart.l2r .node.slide-right,
  .orgchart.r2l .node.slide-right {
    transform: translateX(40px);
  }
  .orgchart .slide-left {
    opacity: 0;
    transform: translateX(-130px);
  }
  .orgchart.l2r .node.slide-left,
  .orgchart.r2l .node.slide-left {
    transform: translateX(-40px);
  }
}
</style>
